import { ComponentPropsWithoutRef } from "react"
import { ChronoUnit } from "@js-joda/core"
import { Label } from "@/components/chadcn/Label"
import { parseFormDateTime, composeFormDateTime } from "@/util/date-utils"

type DateTimePickerProps = {
  /** ISO 8601 with offset, e.g. "2026-04-25T10:30:00+02:00". */
  value: string
  onChange: (value: string) => void
  disabled?: boolean
} & Omit<ComponentPropsWithoutRef<"div">, "onChange">

const DateTimePicker = ({ value, onChange, disabled }: DateTimePickerProps) => {
  const parsed = parseFormDateTime(value)
  const dateValue = parsed.toLocalDate().toString()
  const timeValue = parsed.toLocalTime().truncatedTo(ChronoUnit.MINUTES).toString()

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(composeFormDateTime(e.target.value || dateValue, timeValue, parsed))
  }

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(composeFormDateTime(dateValue, e.target.value || timeValue, parsed))
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Label htmlFor="dateTime-date">Date</Label>
        <input
          id="dateTime-date"
          type="date"
          value={dateValue}
          onChange={handleDateChange}
          disabled={disabled}
          className="block w-full rounded-lg border-0 px-3 py-2 text-base ring-1 ring-inset ring-input focus:ring-2 focus:ring-primary disabled:text-primary-contrast/60"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Label htmlFor="dateTime-time">Time</Label>
        <input
          id="dateTime-time"
          type="time"
          value={timeValue}
          onChange={handleTimeChange}
          disabled={disabled}
          className="block w-full rounded-lg border-0 px-3 py-2 text-base ring-1 ring-inset ring-input focus:ring-2 focus:ring-primary disabled:text-primary-contrast/60"
        />
      </div>
    </div>
  )
}

export default DateTimePicker
